﻿import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, DistributorModel, EntityModel, ResponseDeleteModel } from '../api.models'
import { LoginService } from './api.login.service'
import { CommonHelper } from '../../../helpers/common-helper'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'

export interface IDistributorsService {
    getDistributors(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    getAllDistributors(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    getDistributorRoles(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    createDistributor(req): ng.IPromise<DistributorModel>
    getDistributor(id, state?: any): ng.IPromise<DistributorModel>
    getDistributorToEdit(id, state?: any): ng.IPromise<EntityModel>
    deleteDistributor(id): ng.IPromise<ResponseDeleteModel>
}

export class DistributorsService implements IDistributorsService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getDistributors(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.distributors.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getAllDistributors(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.distributors['getAllDistributors']
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getDistributorRoles(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.distributors['getDistributorRoles']
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.UserRolesList, (<any>result).toJSON())
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getDistributor(id, state: any = {}) {
        var get = this.apiResource.distributors.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    getDistributorToEdit(id, state: any = {}) {
        var getDistributorToEdit: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.distributors['getDistributorToEdit']
        state.request = getDistributorToEdit({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    createDistributor(req): ng.IPromise<DistributorModel> {
        return this.apiResource.distributors.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    deleteDistributor(id): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.distributors.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
}
